declare const Bioz: any;

import { Observable, of, Subject, switchMap } from "rxjs";
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TfScriptLoaderService } from "@app/modules/tf-script-loader";

import { BiozResponseType } from '@app/modules/bioz';
import { BiozRecordInterface } from "@app/modules/bioz";
import { BiozPendingObservableInterface } from "@app/modules/bioz";

enum Status {
    initial = "initial",
    loading = "loading",
    loaded = "loaded"
}

@Injectable({
    providedIn: 'root'
})
export class TfBiozWidgetService {

    private status: Status = Status.initial;

    private biozDataUrl = "https://back-gene-8.bioz.com/get_widget_data_multi_v9/";

    private biozConfig = {
        type: "Assay Id",
        company: "Thermo Fisher",
        form_url: "//back-gene-8.bioz.com",
        key: "",
        form_mobile: false
    };

    private widgetObj = null;

    private observables: BiozPendingObservableInterface[] = []

    private biozRecords: Record<string, BiozRecordInterface> = {};

    constructor(
        private scriptLoaderService: TfScriptLoaderService,
        private httpClient: HttpClient
    ) {
    }

    loadBiozLibrary(): Observable<boolean> {

        if (this.status == Status.loaded) {
            return of(true);
        }

        return this.scriptLoaderService.loadScript('https://cdn.bioz.com/assets/packages/bioz.js').pipe(
            switchMap(() => {
                this.widgetObj = new Bioz.tf_widget_obj(this.biozConfig);
                return of(true);
            })
        );

    }

    drawWidget(productID: string) {
        this.widgetObj.request_widget_data_internal(productID, productID);
    }

    getCitationsCount(arrProductIds): void {

        const query = arrProductIds.join(",");

        const params = new HttpParams().set('qx', query);
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        this.httpClient.post<BiozResponseType>(this.biozDataUrl, params, {headers: headers})
            .subscribe({
                    next: (response) => {
                        if (response.status == "ok" && response.records.length) {

                            response.records.forEach((record) => {
                                this.biozRecords[record.key] = record;
                            });

                            let pendingObservable = this.observables.shift();

                            while (pendingObservable) {

                                if (this.biozRecords[pendingObservable.id]) {
                                    pendingObservable.subject.next(this.biozRecords[pendingObservable.id]);
                                    pendingObservable.subject.complete();
                                } else {
                                    pendingObservable.subject.next(null);
                                    pendingObservable.subject.complete();
                                }

                                pendingObservable = this.observables.shift();

                            }

                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                }
            );

    }

    preloadCitations(productIds: string[]): void {
        this.getCitationsCount(productIds);
    }

    getCitationsData(productId: string): Observable<BiozRecordInterface> {
        if (this.biozRecords[productId]) {
            return of(this.biozRecords[productId]);
        }

        const data: BiozPendingObservableInterface = {
            id: productId.toLocaleLowerCase(),
            subject: new Subject<BiozRecordInterface>()
        };

        this.observables.push(data);

        return data.subject;

    }

}
